import ArrUpIcon from "../ui/ArrUpIcon";
import CloseIcon from "../ui/CloseIcon";
import searchStore from "../../store/searchStore";
import { dateToMonth, declOfNum } from "../../lib/utils";
import FormCardDetails from "./FormCardDetails";
import BookingPrintServices from "./BookingPrintServices";

function BookingFormCard({
  booking,
  hoteldata,
  step = 1,
  prevStep,
  nextStep,
  datein,
  dateout,
  onClose,
  scrolled = 0,
}) {
  return (
    <div className="bookingCard bookingCard__mob bookingCard__dates tar mob_show">
      <div className="dfsp mb12">
        <div>
          <span className="dates">
            {dateToMonth(datein)} – {dateToMonth(dateout)}
          </span>
          <span className="guest">
            {declOfNum(
              searchStore.guestsCount + searchStore.guestsChildren?.length || 0,
              ["гость", "гостя", "гостей"],
            )}
          </span>
        </div>
        <div>
          <span className="bookingClose curp" onClick={onClose}>
            <CloseIcon />
          </span>
        </div>
      </div>
      <div className="prices">
        <div className="dfsp">
          <span className="b textLimit">
            {step !== "contacts" ? "Проживание" : hoteldata.room_name}
          </span>
          <span className="ml6">
            {booking.prices.living +
              booking.selectedTariffs.reduce(
                (total, obj) => total + obj.price_sum,
                0,
              ) +
              booking.selectedAdditionalTariffs.reduce(
                (total, obj) => total + obj.price_sum,
                0,
              )}
            &nbsp;₽
          </span>
        </div>
        {step === "contacts" && (
          <p className="services gray">
            По тарифу {hoteldata.tariffs.base.name}
          </p>
        )}

        {booking.selectedServices?.length > 0 && (
          <>
            <div className="dfsp mt6">
              <span className="b">Услуги</span>
              <span>
                {booking.selectedServices.reduce(
                  (total, obj) => total + obj.sum,
                  0,
                )}{" "}
                ₽
              </span>
            </div>
            <BookingPrintServices booking={booking} />
            {/* <p className="services gray ml6">
              {booking.selectedServices
                .map((service) => service.name)
                .join(", ")}
            </p> */}
          </>
        )}
        {booking.selectedServices?.length > 0 && (
          <div className="totalPrice tar">{booking.prices.total} ₽</div>
        )}
      </div>
      <div className="navs dfsp dfa mt6">
        <div>
          <p className="changeTariff" onClick={prevStep}>
            <ArrUpIcon w={20} h={10} fill="#36549C" />
            &nbsp;назад
          </p>
        </div>
        <div style={{ flexGrow: 1 }}>
          <button className="bookingCard__nextBtn" onClick={nextStep}>
            {step !== "contacts" ? "Далее" : "Забронировать"}
          </button>
        </div>
      </div>
      <div className="details dfsp mt12">
        <div className="step ml6 mr6">
          шаг {step == "contacts" && hoteldata.steps_count}{" "}
          {step == "services" && "2"} {step == "1" && "1"} из{" "}
          {hoteldata.steps_count}
        </div>
        <div className="fg1 list">
          <FormCardDetails booking={booking} scrolled={scrolled} />
        </div>
      </div>
    </div>
  );
}

export default BookingFormCard;
